export class RecoveryCodeCopy {
  constructor({
    source,
    feedback,
    clipboard,
    selectionProvider = () => window.getSelection(),
    rangeFactory = () => document.createRange()
  }) {
    this.source = source
    this.feedback = feedback
    this.clipboard = clipboard
    this.selectionProvider = selectionProvider
    this.rangeFactory = rangeFactory
  }

  async copy() {
    try {
      await this.clipboard.writeText(this.source.value ?? this.source.textContent)
      this.feedback.textContent = "Skopiowano"
    } catch (_error) {
      this.feedback.textContent = "Nie udało się skopiować. Zaznacz kody i skopiuj ręcznie."
      this.source.focus()
      const selection = this.selectionProvider()
      const range = this.rangeFactory()
      range.selectNodeContents(this.source)
      selection.removeAllRanges()
      selection.addRange(range)
    }
  }
}
